<template>
    <div></div>
</template>

<script>
    export default {
        name: "Reports"
    }
</script>

<style scoped>

</style>